import { STATUS } from '@app/constants/commonConstants';

export const notificationInitialStore = {
  data: [],
  notificationStatus: STATUS.IDLE,
  recordSetCount: 0
};
